import React, { Component, Suspense } from 'react'
import { Router } from 'react-router-dom'
import history from './history'
import LoadingSpinner from '../components/partials/LoadingSpinner'
import UnifiedRoutesContainer from './UnifiedRoutesContainer'
import '../styles.desktop.css'

class UnifiedPageLayout extends Component {
  render () {
    return (
      <Router basename='/' history={history}>
        <div className='container-fluid' style={{
          width: '100%',
          marginRight: 'auto',
          marginLeft: 'auto'
        }}>
          <Suspense fallback={<LoadingSpinner />}>
            <UnifiedRoutesContainer />
          </Suspense>
        </div>
      </Router>
    )
  }
}

export default UnifiedPageLayout 